module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-wrapper"
  }, [_c('v-container', {
    staticClass: "pb-0"
  }, [_c('v-layout', {
    staticClass: "organization",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "organization-list-left",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('organization-add-btn', {
    on: {
      "child-action": _vm.showMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-3 pt-2",
    attrs: {
      "id": "organization-list"
    }
  }, [_c('ul', [_c('tree-view', {
    attrs: {
      "organization": _vm.treeData
    },
    on: {
      "child-action": _vm.selectOrganization
    }
  })], 1)])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "organization-detail-right",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('router-view', {
    ref: "child",
    attrs: {
      "selectedOrganizationId": _vm.selectedOrganizationId,
      "roles": _vm.roles,
      "organizations": _vm.organizations
    },
    on: {
      "child-action": _vm.showMessage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-8478c660","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountOrganizations.vue
// module id = 1940
// module chunks = 0